<template>
  <div class="home">
    <HeadBar @openNavigation="$event => (navigationIsShow = $event)" />
    <b-row class="home-main no-gutters">
      <b-col
        class="home__navigation"
        :class="{ 'home__navigation-isShow': navigationIsShow }"
      >
        <Navigation :navigationIsShow="navigationIsShow" />
      </b-col>
      <b-col>
        <section class="home__main-content">
          <b-container fluid>
            <router-view />
          </b-container>
        </section>
        <footer>
          <p class="copyright text-right pr-4">資通行動科技 v.2.0.0</p>
        </footer>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import HeadBar from '@/components/commen/HeadBar';
import Navigation from '@/components/commen/Navigation';

export default {
  name: 'Home',
  components: {
    HeadBar,
    Navigation
  },
  data() {
    return {
      navigationIsShow: false
    };
  }
};
</script>

<style lang="scss" scoped>
.home {
  &__main {
    min-height: 100vh;
    &-content {
      min-height: 100vh;
      position: relative;
      padding-top: 120px;
    }
  }

  &__navigation {
    border-right: 1px solid $border-gentle;
    overflow: hidden;
    transition: flex 0.3s;
    flex: 0 0 0;
    &-button {
      position: fixed;
      left: -1px;
      top: 80px;
      border-radius: 0 5px 5px 0;
      padding: 5px;
      border: 1px solid #d9dee4;
      background-color: #fff;
      &:focus {
        box-shadow: none;
      }
      &:hover {
        background-color: #ededed;
        color: #6c757d;
      }
    }

    &-isShow {
      flex: 0 0 18%;
    }
  }
}

.container-fluid {
  padding: 0;
}

.copyright {
  color: #73879c;
  font-size: 13px;
}

footer {
  clear: both;
  padding-top: 50px;
}
</style>
